class CardRequestFailureController {
  constructor() {}

  errorMsgIsEmpty() {
    return !this.errorMsg;
  }
}

export default CardRequestFailureController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestFailure/cardRequestFailure.controller.js